import { Base } from '@studiometa/js-toolkit';
import fetchSection from '../../utils/fetchSection.js';

/**
 * Search page: results are updated while typing, submitting reloads the page.
 */
export default class SearchPage extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'SearchPage',
    refs: ['input', 'container', 'loader', 'status'],
    options: {
      url: String,
      sectionId: String,
      delay: {
        type: Number,
        default: 400,
      },
    },
  };

  timeout = null;

  /**
   * @type {AbortController|null}
   */
  controller = null;

  /**
   * Debounce the update while typing.
   * @returns {void}
   */
  onInputInput() {
    clearTimeout(this.timeout);
    this.controller?.abort();

    this.$refs.loader.hidden = false;
    this.timeout = setTimeout(
      () => this.update(this.$refs.input.value.trim()),
      this.$options.delay,
    );
  }

  /**
   * Render the section for the given term and keep the URL in sync.
   * @param {string} term The search term.
   * @returns {Promise<void>}
   */
  async update(term) {
    const controller = new AbortController();
    this.controller = controller;

    const params = new URLSearchParams();

    if (term) {
      params.set('q', term);
      params.set('options[prefix]', 'last');
    }

    const url = term ? `${this.$options.url}?${params}` : this.$options.url;

    try {
      const section = await fetchSection(url, this.$options.sectionId, controller.signal);
      const container = section.querySelector('[data-ref="container"]');

      this.$refs.container.innerHTML = container.innerHTML;
      this.$refs.status.textContent =
        this.$refs.container.querySelector('[data-search-status]')?.textContent.trim() ?? '';
      window.history.replaceState(window.history.state, '', url);
    } catch (error) {
      if (error.name !== 'AbortError') {
        globalThis.reportError?.(error);
      }
    } finally {
      if (!controller.signal.aborted) {
        this.$refs.loader.hidden = true;
      }
    }
  }
}
